import { useBrandStore } from '../../context';
import { produce } from 'immer';

import TextInput from '../../../../inputs/form-inputs/TextInput';

import { FONT_KEYS } from '../../lib';

export default function FontInput() {
  const styles = useBrandStore((state) => state.styles);
  const setStyle = useBrandStore((state) => state.setStyle);
  const fonts = useBrandStore((state) => state.styles.fonts);

  return (
    <div className="d-flex flex-column gap-3">
      {FONT_KEYS.map((item) => (
        <div key={item.key} className="mb-2">
          <label className="form-label">
            <b>{item.label}</b>
          </label>
          <TextInput
            value={fonts[item.key] || ''}
            onChange={(e) =>
              setStyle(
                produce(styles, (draft) => {
                  draft['fonts'][item.key] = e.target.value;
                }),
              )
            }
          />
          <p className="text-muted mb-0 mt-2">{item.description}</p>
        </div>
      ))}
    </div>
  );
}
